import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { images, videoUrl } from '../data/landing';
export function VslSection() {
  return <section aria-labelledby="vsl" className="bg-cream px-5 py-14 sm:py-20" data-id="element-149" data-mp="27ll3r5tu1g6w">
      <Reveal data-id="element-150" data-mp="27ji3zu2vo8oz">
        <div id="vsl" data-id="element-151" data-mp="22mhzhnlofdzz">
          <SectionHeading title={<>
                Descubre cómo funciona nuestro programa{' '}
                <span className="whitespace-nowrap" data-id="element-153" data-mp="1xnx0fri5v0d4">EL ESCUDO DE MAMÁ</span>
              </>} subtitle="Si sientes que tu casa vive atrapada en un ciclo de mocos, tos, cansancio y noches sin dormir, en este video aprenderás cómo resolver ese problema." data-id="element-152" data-mp="22n053au8b4kk" />
        </div>
      </Reveal>
      <Reveal delay={0.08} className="mx-auto mt-8 max-w-3xl" data-id="element-154" data-mp="1jnm8sm911hqw">
        <div className="rounded-[26px] border border-sage-light bg-white p-2.5 shadow-lift sm:p-3" data-id="element-155" data-mp="1jpgsjx8kb3te">
          <div className="relative aspect-video overflow-hidden rounded-[20px] bg-forest-deep" data-id="element-156" data-mp="3izyoi1tahfip">
            <video src={videoUrl} poster={images.bundle} controls playsInline preload="metadata" className="absolute inset-0 h-full w-full object-contain" data-id="element-157" data-mp="3e2gcu3nw0m70">
              Tu navegador no soporta la reproducción de video.
            </video>
          </div>
        </div>
      </Reveal>
    </section>;
}